import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { faCheck, faExclamation, faFlag } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "wf-color-category",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule],
  styleUrl: "color-category.component.css",
  host: {
    "[style.display]": "'inline-block'",
    "[style.min-width]": "'75px'",
  },
  template: `
    <div class="color-category color-category--{{ level() }}">
      @if (showIcon()) {
        <div class="icon-square print-hide">
          <fa-icon [icon]="icon()"/>
        </div>
      }
      <div class="color-category-text">
        <ng-content/>
      </div>
    </div>
  `,
})
export class ColorCategoryComponent {
  readonly level = input.required<'red' | 'yellow' | 'green' | 'purple'>();
  readonly showIcon = input(true);

  readonly icon = computed(() => {
    switch (this.level()) {
      case 'red':
        return faFlag;
      case 'yellow':
        return faEye;
      case 'green':
        return faCheck;
    }
    return faExclamation;
  });
}
